
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RegisterVM, ClientAssessmentVM, HarmingYourselfOrOthers } from '../models';
import { VerifyAccountResponse } from '../models/VerifyAccountResponse';


@Injectable()
export class SignupService {

  public model: RegisterVM;
  public resendToken: string = null;
  public overrideClientAssessment = false;

  constructor(private http: HttpClient) {
    this.resetRegistration();
  }

  public resetRegistration(): void {
    this.model = new RegisterVM();
    this.model.assessment = new ClientAssessmentVM();
  }

  public validateOrgID(orgid: string): Observable<boolean> {
    return this.http.post('/api/signup/validateorgid/', JSON.stringify(orgid), this.getHttpOptions(true)).pipe(
      map(resp => resp != null));
  }

  public validateEmailAddress(emailAddress: string): Observable<boolean> {
    return this.http.post('/api/signup/validateemail', JSON.stringify(emailAddress), this.getHttpOptions(false)).pipe(
      map(resp => !!resp));
  }

  public isStep1Complete(): boolean {
    return (this.model.email != null && this.model.password != null);
  }

  public isStep2Complete(): boolean {

    //Override
    if (this.overrideClientAssessment) {
      return true;
    }

    //Q1
    if (this.model.assessment.presentingIssue1 == null) {
      return false;
    }

    //Q2
    if (this.model.assessment.prescribedMedication == null) {
      return false;
    }
    else if (this.model.assessment.prescribedMedication) {
      if (this.model.assessment.medicationFor1 == null) {
        return false;
      }
    }

    //Q3
    if (this.model.assessment.hadPastThoughtsOfEndingLife == null) {
      return false;
    }
    else if (this.model.assessment.hadPastThoughtsOfEndingLife) {
      if (this.model.assessment.everAttemptedToEndYourLife == null) {
        return false;
      }
    }

    //Q4
    if (this.model.assessment.consideredHarmingYourselfOrOthers == null) {
      return false;
    }

    //Q5
    if (this.model.assessment.haveFamilySupport == null) {
      return false;
    }

    return true;
  }

  public isStep3Complete(): boolean {

    if (this.model.firstname == null) {
      return false;
    }

    if (this.model.lastname == null) {
      return false;
    }

    if (this.model.displayName == null) {
      return false;
    }

    if (this.model.dateOfBirth == null) {
      return false;
    }

    if (this.model.gender == null) {
      return false;
    }

    if (this.model.nationality == null) {
      return false;
    }

    if (this.model.mobile == null) {
      return false;
    }

    if (this.model.addressLine1 == null) {
      return false;
    }

    if (this.model.city == null) {
      return false;
    }

    if (this.model.postcode == null) {
      return false;
    }

    if (this.model.country == null) {
      return false;
    }

    return true;
  }

  public isClientAccessmentAccepted(): boolean {
    let result = true;

    //Override
    if (this.overrideClientAssessment) {
      return result;
    }

    if (this.model.assessment.everAttemptedToEndYourLife) {
      result = false;
    }

    if (this.model.assessment.consideredHarmingYourselfOrOthers != HarmingYourselfOrOthers.noneToBoth) {
      result = false;
    }

    return result;
  }

  public signup(): Observable<string> {
    return this.http.post('/api/signup/register', this.model, { ...this.getHttpOptions(false), responseType: 'text' }).pipe(
      map(resp => resp));
  }

  public resendVerifyAccount(token: string): Observable<boolean> {
    return this.http.post('/api/signup/resend', JSON.stringify(token), this.getHttpOptions(false)).pipe(
      map(resp => !!resp));
  }

  public verifyAccount(token: string): Observable<VerifyAccountResponse> {
    return this.http.post<VerifyAccountResponse>('/api/signup/verifyaccount', JSON.stringify(token), this.getHttpOptions(false));
  }

  protected getHttpOptions(authenticated: boolean, params?: URLSearchParams) {
    if (authenticated) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      });
      return { headers };
    }
    else {
      let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return params ? { headers, search: params } : { headers };
    }
  }

}
